/**
 * Matches the promise the inputs' helper text makes: a plain number with no
 * commas, spaces, or symbols. Deliberately stricter than Number() or
 * safeParseFloat - the resolver guard and the Lob check handler both parse with
 * comma-stripping safeParseFloat, so an ambiguous value like "12,50" (meant as
 * 12.50, parsed as 1250) must never be persisted in the first place.
 */
export const isPlainNumber = (value: string): boolean => /^\d+(\.\d+)?$/.test(value);
